import React from "react";
import FAQData from "./FAQData";
import { useParams, useLocation } from "react-router-dom";
import ContentBelow from "../../components/ContentBelow";
import Head from "../../components/Head";
import background from "../../images/BlogHeadingBackGround.jpg";
import FAQTreeView from "./FAQTreeView";
import classes from "../../components/FAQ.module.css";
import { Link } from "react-router-dom";

export default function FAQArticle() {
  const { name } = useParams();
  const slugify = (category) => category.replace(/\s+/g, "-").toLowerCase();
  //const faq = FAQData.find((f) => f.id === id);
  const post = FAQData.find((faq) => slugify(faq.category) === name);

  if (!post) return <p>FAQ not found</p>;
  function ArticleData({ data }) {
    return (
      <>
        {data.description?.map((item, index) => (
          <p key={index}>{item}</p>
        ))}

        {data.p1 && <p>{data.p1}</p>}

        {data.ULHeading && <h5 className="mt-3">{data.ULHeading}</h5>}
        {data.ul1Heading && <p>{data.ul1Heading}</p>}
        {data.ul?.length > 0 && (
          <ul>
            {data.ul.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}

        {data.p2 && <p>{data.p2}</p>}
        {data.p3 && <p>{data.p3}</p>}
        {data.p4 && <p>{data.p4}</p>}

        {data.ulp4?.length > 0 && (
          <ul>
            {data.ulp4.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}

        {data.p5 && <p>{data.p5}</p>}

        {data.summary?.length > 0 && (
          <>
            <h4>{data.summary[0]}</h4>

            <ul>
              {data.summary.slice(1).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </>
        )}
      </>
    );
  }
  function ArticleLayout({ children }) {
    return (
      <div className={`container mt-5 ${classes.article}`}>
        <div className="row">
          {/* LEFT SIDEBAR */}
          <aside className="col-lg-3 col-md-4 mb-4">
            <FAQTreeView />
          </aside>

          {/* MAIN CONTENT */}
          <main className="col-lg-9 col-md-8">
            <div className="row">
              {/* IMAGE */}
              {post.ImgSrc && (
                <div className="col-lg-6 mb-3">
                  <img
                    src={post.ImgSrc}
                    alt={post.category}
                    className="img-fluid rounded"
                  />
                </div>
              )}

              {/* TEXT */}
              <div className="col-lg-6">
                <h3 className="mb-3">{post.question}</h3>
                <div className="article-content">{children}</div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <>
      <Head imageUrl={background}>
        <h2 className="heading_space">FAQs</h2>
      </Head>
      <ContentBelow>
        <div className="col-lg-11 mt-4 mx-auto">
          <h2 className={classes.h2}>
            Frequently Asked{" "}
            <span className="" style={{ color: "#68B0ED" }}>
              Questions
            </span>
          </h2>
          <p className=" text-center">
            Got questions? Our FAQs have the answers!
          </p>
        </div>
        <div className="row">
          <div className=" col-md-5 col-lg">
            <ArticleLayout
              children={<ArticleData data={post} />}
            ></ArticleLayout>
          </div>
        </div>
      </ContentBelow>
    </>
  );
}
